import React from 'react';
import { Radio as AntRadio } from 'antd-v5';
import './style.less';
function Radio(props) {
  const { ...nativeProps } = props;

  return <AntRadio {...nativeProps} className='ui-radio' />;
}
Radio.Group = AntRadio.Group;
export default Radio;
